import React from 'react';

const ParseHTML = React.createClass({
    propTypes: {
        children: React.PropTypes.node.isRequired
    },
    render: function() {
        return (
            <span dangerouslySetInnerHTML={{__html: this.props.children}} />
        );
    }
});

export default ParseHTML;



// WEBPACK FOOTER //
// ./src/js/components/ParseHTML.js